import { Component, Input, SimpleChanges } from '@angular/core';
import { List } from 'immutable';

@Component({
    selector: 'yt-info-box',
    templateUrl: './info-box.component.html'
})
export class InfoBox {
    constructor(){
    }

    @Input() Icon: string;
    @Input() Label: string;
    @Input() ChartData: List<any>;
    @Input() ValueColumn: string;
    @Input() Color: string = 'primary';
    @Input() NumberFormat: string = '1.0-0';
    @Input() ValueSuffix: string;

    value: number;
    trend: number;

    ngOnChanges(changes: SimpleChanges){
        if(this.ChartData && this.ChartData.count() > 0 && this.ValueColumn && this.ValueColumn.length > 0){
            this.calculateValue();
            this.calculateTrend();
        }
    }

    private calculateValue(){
        //this.value = this.ChartData.forEach((sum, item) => sum + item[this.ValueColumn], 0);
        this.value = this.ChartData.reduce((sum, item) => sum + item[this.ValueColumn], 0);
    }

    private calculateTrend(){
        let last = this.ChartData.get(this.ChartData.count() - 1)[this.ValueColumn];
        if(last == 0)
            last = 1;
        //let first = this.ChartData.get(0)[this.ValueColumn];
        let first = this.ChartData.get(this.ChartData.count() - 2)[this.ValueColumn];
        if(first == 0)
            first = 1;
        this.trend = this.ChartData.get(this.ChartData.count() - 1)[this.ValueColumn] / this.ChartData.get(0)[this.ValueColumn] * 100;
        this.trend = last / first;
        //if(this.trend < 1)
            //this.trend = 1 - this.trend;
        this.trend = this.trend * 100 - 100;
    }
}